import React from 'react';
import classNames from 'classnames';
import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import { withRouter } from 'react-router-dom';
import { getClientStore } from '../../utils/util';
import './boxContainer.css';
import split from 'lodash/split';
import get from 'lodash/get';
import css from '../../styles/modules/BoxContainer/boxcontainer.module.css';
import {
  useAllTenants,
  useAllBrandingsFromTenant,
  useDefaultBrandingFromTenant,
} from '../../utils/service/service_tenant_api';
import { getQueryVariable } from '../../utils/util';
import sideImage from '../../styles/assets/bg.png';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Purpose from './WireFlow/Purpose';
import { createLogButton } from './lib/createLogButton';
import { Logo } from './Logo';
import SpinnerLoader from '../SpinnerLoader/SpinnerLoader';

const BoxContainer = ({
  children,
  className = '',
  color = 'default',
  withBorder = true,
  withDoubleBorder = false,
  withLogButton = false,
  widest = false,
  internalBox = false,
  history,
  showLogin = false,
  showLoginButton = false,
  withTopLogo = false,
}) => {
  const { user } = getClientStore();
  const tenantIdentifier = split(window.location.hostname, '.')[0];
  const { tenant } = useAllTenants(tenantIdentifier);
  const { branding } = useAllBrandingsFromTenant(get(tenant, '_id', ''), true);
  const { defaultBranding } = useDefaultBrandingFromTenant();
  const brandLogo = branding
    ? get(branding, 'logoURL')
    : get(defaultBranding, 'logoURL');
  const path = window.location.search.split('?')[2];
  const selectedTab = getQueryVariable(path, 'disbursement') || null;
  const classNameBox = classNames(
    `paymints__box-container paymints__box-container${
      internalBox ? '__internal' : ''
    }--${color} ${className}`,
    {
      'with-border': withBorder,
    },
  );
  const classNameContainer = classNames(
    `paymints__box-container__container paymints__box-container__box-shadow--default`,
    {
      widest: widest,
    },
  );

  const segments = window.location?.pathname.split('/');
  const currentPath = segments[segments.length - 1];
  const excludePaths = ['login', 'create-account', 'account-verification'];
  const showNavigation = !excludePaths.includes(currentPath);
  if (withDoubleBorder) {
    return (
      <>
        {/* {window.location?.pathname === '/create-account/step-3' ? (
          <Purpose
            children={children}
            showLogin={showLogin}
            brandLogo={brandLogo}
            backgroundImage={branding.backgroundImageURL}
            withLogButton={withLogButton}
            selectedTab={selectedTab}
          />
        ) : ( */}
        <div className={classNameContainer}>
          <div className="paymints__box-container__steps" hidden={!selectedTab}>
            <div className="tabs active">Select a Bank Account</div>
            <div
              className={`tabs ${
                selectedTab === 'payment' || selectedTab === 'success'
                  ? 'active'
                  : ''
              }`}
            >
              Accept Your Payment
            </div>
            <div
              className={`tabs ${selectedTab === 'success' ? 'active' : ''}`}
            >
              Success
            </div>
          </div>
          <div className="paymints__box-container__box-shadow">
            {withLogButton &&
              createLogButton(user, brandLogo, history, showLogin, branding)}
            <div className={classNameBox}>
              {withTopLogo && (
                <div>
                  <Logo
                    styleOverride={{
                      padding: '0px',
                      marginLeft: '0px',
                      marginBottom: '32px',
                    }}
                    brandLogo={brandLogo}
                  />
                </div>
              )}
              {children}
            </div>
          </div>
        </div>
        {/* )} */}
      </>
    );
  }

  return (
    <div className={classNameBox}>
      <div>
        {withLogButton &&
          createLogButton(user, brandLogo, history, showLogin, branding)}
        {withTopLogo && (
          <div>
            <Logo
              styleOverride={{
                padding: '0px',
                marginLeft: '0px',
                marginBottom: '32px',
              }}
              brandLogo={brandLogo}
            />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default withRouter(BoxContainer);
